<template>
  <div class="RecommendedTeamCard_page" v-loading="loadingTrue">
    <div
      class="team_card"
      v-for="(item, index) in teamList"
      :key="index"
      @mouseenter="Mover(index)"
      @mouseleave="isShow = -1"
      @click="goRentalDetails(item)"
    >
      <div class="header">
        <div class="item_left">
          <div class="item_img">
            <img
              v-if="item.teamType == 0 && !item.avatarAddress"
              src="@/assets/public/shigongdui60.png"
              alt
            />
            <img
              v-else-if="item.teamType == 1 && !item.avatarAddress"
              src="@/assets/public/banzu60.png"
              alt
            />
            <img v-else :src="item.avatarAddress" alt />
          </div>
        </div>
        <div class="item_right">
          <!-- row1 -->
          <div class="item_title">
            <div class="item_lt single_hide">{{ item.teamName }}
              <!-- <span v-if="item.legalComName!=null && item.legalComName!=''">( {{item.legalComName}} )</span> -->
            </div>
          </div>
          <!-- row2 -->
          <div class="item_tag">
            <span class="tagItem" v-if="item.teamType == 0">施工队</span>
            <span class="tagItem" v-if="item.teamType == 1">班组工队</span>
            <span class="tagItem" v-if="item.teamType == 2">承包商</span>
            <span class="tagItem" v-if="item.teamNumber && item.teamNumber != null">
              团队人数:{{ item.teamNumber }}
            </span>
            <span class="tagItem" v-if="item.contact">
              负责人:{{ item.contact }}
            </span>
            <!-- <span class="tagItem" v-if="!item.teamSize || item.teamSize == '0'">
              团队人数
            </span> -->
            <!-- <span class="tagItem" v-if="item.address">{{ item.address }}</span> -->
          </div>
        </div>
      </div>
      <div class="content">
        <!-- <div class="item_categoryName">
          <el-row :gutter="10">
            <el-col :span="12">
              <div class="item_text single_hide">
                <span class="color6">工队负责人:</span>
                <span class="item_data color3">{{ item.contact }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="item_text single_hide">
                <span class="color6">联系电话:</span>
                <span class="item_data color3">{{
                  item.phoneNumber ? starPhone(item.phoneNumber) : ""
                }}</span>
              </div>
            </el-col>
          </el-row>
        </div> -->
        <div class="item_categoryName">
          <el-row>
            <el-col :span="24">
              <div class="item_text single_hide">
                <span class="color6">工程专业:</span>
                <!-- <span class="item_data color3">{{
                  item.categoryName ? item.categoryName.replace(/,/g," | ") : ""
                }}</span> -->
                  <span class="item_data color3">{{item.category|tocategory}}</span>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="item_five">
          <el-row>
            <el-col :span="24">
              <div class="item_text single_hide">
                <span class="color6">工作区域:</span>
                <span class="item_data color3">
                  {{item.serviceAreaName ? item.serviceAreaName.replace(/、/g," | ") : ""}}
                </span>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="item_footer">
        <div class="time">
          <img src="@/assets/team/locationIcon.png" alt="" />
          <span class="color6">{{
            item.address ? item.address : "--"
          }}</span>
        </div>
      </div>
      <hide-box
        @inByLetDialogClick="inByLetDialogClick"
        v-if="index == isShow"
        :item="item"
        :type="1"
      ></hide-box>
    </div>
    <!-- 函询弹框 -->
    <InByLetDialog
      :dialogVisible="inByLetDialogShow"
      @closeDialog="closeinDialog"
      @cancelDialog="cancelDialog"
      @confirmDialog="confirminDialog"
    ></InByLetDialog>
    <div class="show_more">
      <div class="fold" v-if="showFoldIcon" @click="foldMore">
        收起<i class="el-icon-caret-top"></i>
      </div>
      <div class="more" v-if="showMoreIcon" @click="loadingMore">
        更多<i class="el-icon-caret-bottom"></i>
      </div>
    </div>
  </div>
</template>

<script>
// import { apiRecommendList } from '@/api/apiRecommendList'
// import cookie from '@/storage/cookies.js'
import { apiResignAll } from '@/api/apiResignAll'
export default {
  data () {
    return {
      tableData: [],
      isShow: -1,
      inByLetDialogShow: false,
      loading: false,
      jData: {
        pageSize: 10,
        pageNum: 1,
        provinceNo: '',
        hasMore: false
      }
    }
  },
  props: {
    teamList: {
      type: Array
    },
    loadingTrue: {
      type: Boolean
    },
    showFoldIcon: {
      type: Boolean
    },
    showMoreIcon: {
      type: Boolean
    }
  },
  components: {
    hideBox: () => import('@/views/Home/AllComponents/hideBox'),
    InByLetDialog: () => import('@/components/public/InquiryLetterDialog') // 函询弹框
  },
  created () {

  },
  methods: {
    /** @name 点击更多 */
    loadingMore () {
      this.$emit('loadingMore')
    },
    /** @name 点击收起 */
    foldMore () {
      this.$emit('foldMore')
    },
    goRentalDetails (item) {
      // 1企业 0 个人
      let query = {}
      if (item.isCompany === 1 && item.teamType === 0) {
        query = {
          companyNo:item.companyNo,
          teamNo:item.no
        }
      } else {
        query = {
          userNo:item.userNo,
          teamNo: item.no
        }

      }
      this.$router.push({
        path: './ConstructionTeamDetail',
        query: query
      })
    },
    /** @name 函询按钮点击方法 */
    async inByLetDialogClick (item) {
      if (this.$store.state.loginType) {
        this.inByLetDialogShow = true
        this.hideBoxData = item
      } else {
        this.loginIndex()
      }
    },
    /** @name 函询关闭 */
    closeinDialog (val) {
      this.inByLetDialogShow = val
    },
    /** @name 函询取消 */
    cancelDialog (val) {
      this.inByLetDialogShow = val
    },
    /** @name 函询提交 */
    async confirminDialog (obj) {
      this.$set(obj, 'teamCompamyNo', this.hideBoxData.companyNo)
      this.$set(obj, 'teamUserNo', this.hideBoxData.userNo)
      this.$set(obj, 'markName', this.hideBoxData.name)
      this.$set(obj, 'markType', 4)
      let params = { markId: this.hideBoxData.no, ...obj }
      let res = await apiResignAll.getSaveForBid(params)
      if (res.data.code === 200) {
        this.$message.success('提交成功')
        this.inByLetDialogShow = false
      } else {
        this.$message.error('提交失败')
      }
    },
    Mover (index) {
      this.isShow = index
    }
  },
  filters:{
    tocategory(v){
      return v.split("|").pop()
    }
  }
}
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
.color3 {
  color: #333333;
}
.color6 {
  color: #666666;
}
.RecommendedTeamCard_page {
  .show_more {
    width: 100%;
    display: flex;
    justify-content: center;
    .fold {
      color: #ff6600;
      margin-right: 10px;
      font-size: 14px;
      cursor: pointer;
    }
    .more {
      color: #b79255;
      font-size: 14px;
      cursor: pointer;
    }
  }
  .warp {
    display: flex;
  }
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 20px 0 10px;
  .team_card {
    .single_hide {
      // 单行隐藏
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    width: 570px;
    height: 178px;
    color: #666666;
    font-size: 14px;
    border: 1px solid #e4e7ed;
    background: #fff;
    cursor: pointer;
    margin: 0px 0px 10px 20px;
    transition: All 0.4s ease-in-out;
    &:hover {
      transform: translateY(-20px);
      border: 1px solid #b79255;
      border-bottom: none;
    }
    .header {
      display: flex;
      padding: 10px 15px;
      .item_left {
        width: 60px;
        margin-right: 20px;
        .item_img {
          width: 60px;
          height: 60px;
          border: 1px solid #e4e7ed;
          border-radius: 6px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 6px;
          }
        }
      }
      .item_right {
        flex: 1;
        .item_title {
          display: flex;
          color: #333333;
          font-size: 16px;
          margin-bottom: 7px;
          .item_lt {
            max-width: 235px;
            margin-right: 15px;
          }
          .item_rt {
            width: 165px;
            display: flex;
            .item_text {
              max-width: 165px;
              display: inline-block;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;

            }
          }
        }
        .item_tag {
          margin-bottom: 7px;
          .tagItem {
            height: 24px;
            line-height: 24px;
            background: rgba(2, 134, 223, 0.1);
            color: #409ee9;
            font-size: 12px;
            display: inline-block;
            margin-right: 10px;
            padding: 0 5px;
          }
        }
        .item_categoryName {
          margin-bottom: 7px;
          .item_text {
            width: 413px;

          }
        }
        .item_five {
          .btn {
            width: 76px;
            height: 30px;
            border: 1px solid #b79255;
            color: #b79255;
            font-size: 14px;
            text-align: center;
            line-height: 30px;
          }
        }
      }
    }
    .content {
      padding: 0px 15px;
      padding-bottom: 10px;
      border-bottom: 1px dashed #e4e7ed;
      .item_categoryName {
        margin-bottom: 7px;
        .item_text {
          width: 413px;
          .item_data{
              color:#333333
            }
        }
      }
      .item_five {
        .btn {
          width: 76px;
          height: 30px;
          border: 1px solid #b79255;
          color: #b79255;
          font-size: 14px;
          text-align: center;
          line-height: 30px;
        }
      }
    }
    .item_footer {
      display: flex;
      justify-content: flex-start;
      padding: 5px 5px 0 15px;
      line-height: 30px;
      .time {
        display: flex;
        flex: 1;
        align-items: center;
        span{
          margin-left: 5px;
        }
      }
      .Btn {
        width: 76px;
        height: 30px;
        border: 1px solid #b79255;
        color: #b79255;
        font-size: 14px;
        text-align: center;
        line-height: 30px;
        margin-right: 10px;
      }
    }
  }
}
</style>
